import React from 'react';
import axios from 'axios';
import Boton from './Boton'
import './css/Login.css';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      user:'',
      pass:''
    }
  }

  ingresar(){
    const usuario = {
      user: this.state.user,
      pass: this.state.pass
    }
    axios.post(localStorage.getItem('apiUrl') + '/api/geo/users/login',usuario)
    .then((res) => {
      if (res.data.status === "ok"){
        sessionStorage.setItem('token', res.data.newToken);
        sessionStorage.setItem('tipo', res.data.user.tipo_usuario_id);
        if (res.data.user.cambiarpass === true){
          this.props.history.push('/cambiarpass');
        } else {
          this.props.history.push('/');
        }
      } else {
        alert(res.data.error)
        this.setState({pass:''})
      }
    })
    .catch((err) => {
      console.log(err)
      alert(err);
    })
  }

  presionaTecla(e){
    if (e.key === "Enter"){
      this.ingresar();
    }
  }

  render(){
    const {user, pass} = this.state;
    return(
      <div className="Todo Login" style={{paddingTop:'10vh'}}>
        <div className="Container" onKeyDown={(e) => this.presionaTecla(e)}>
          <h2 style={{color:'white'}}>Bienvenido!</h2>
          <input
            type="text" style={{flex:1}}
            onChange={(e)=>this.setState({user:e.target.value})}
            value={user}
            placeholder="Usuario"
          />
          <input
            type="password" style={{flex:1}}
            onChange={(e)=>this.setState({pass:e.target.value})}
            value={pass}
            placeholder="Contraseña"
          />
          <Boton
            backgroundColor="#00a5e5"
            titulo="Ingresar"
            onClick={() => this.ingresar()}
          />
        </div>
      </div>
    );
  }
}

export default Login;
